function addFragments<C, F>(component: C, fragments: F) {
  type withFragments = { fragments: F } & C;
  // eslint-disable-next-line no-param-reassign
  (component as withFragments).fragments = fragments;
  return component as withFragments;
}

export default addFragments;
